import type { FC, PropsWithChildren, ReactNode } from "react";
import React, { useContext } from "react";

import { HeadingLevelContext } from "../contexts/heading-level/context.ts";

interface HSectionProps {
  readonly heading: ReactNode;
}

export const HSection: FC<PropsWithChildren<HSectionProps>> = ({
  children,
  heading,
}) => {
  const level = useContext(HeadingLevelContext);

  return (
    <>
      {heading}
      <HeadingLevelContext.Provider value={level + 1}>
        {children}
      </HeadingLevelContext.Provider>
    </>
  );
};
